import { Outlet } from "react-router-dom";
import AppShell from "@/components/shell/app-shell";
import { InfoBanner } from "@/components/ui/banner";
import { ENTERPRISE_WALLET_NAV_SECTIONS } from "@/lib/constants";
import { useAuthStore } from "@/stores/auth-store";

export function AppLayout({ variant }: { variant?: "enterprise" }) {
  const experience = useAuthStore((s) => s.experience);
  const pendingInvites =
    experience.source === "api"
      ? experience.invites.filter((invite) => invite.status !== "")
      : [];
  const hasDeniedState =
    experience.source === "api" &&
    experience.deniedState != null &&
    experience.deniedState.reasonCode !== "" &&
    experience.deniedState.title !== "";

  const isNonProd =
    experience.source === "api" &&
    experience.environment.mode !== "production";

  return (
    <AppShell navSections={ENTERPRISE_WALLET_NAV_SECTIONS}>
      {isNonProd && (
        <InfoBanner className="mb-5" variant="info" label={experience.environment.deploymentProfile}>
          <span>{experience.environment.claimBoundary}</span>
        </InfoBanner>
      )}
      {hasDeniedState && experience.deniedState && (
        <InfoBanner className="mb-5" variant="warning" title={experience.deniedState.title}>
          <span>{experience.deniedState.remediation}</span>
        </InfoBanner>
      )}
      {pendingInvites.length > 0 && (
        <InfoBanner className="mb-5" variant="info" title="Pending invites">
          <span>
            {pendingInvites.length} invite{pendingInvites.length === 1 ? "" : "s"} require follow-up.
            {" "}
            {pendingInvites.map((invite) => invite.supportReference).filter(Boolean).join(", ")}
          </span>
        </InfoBanner>
      )}
      <Outlet />
    </AppShell>
  );
}
